const alternatePlacements = {
  SalonRegularConServiciosYAyudaSuplementaria: 105,
  SalonRegularConServiciosDeSalonRecurso: 106,
  SalonRegularConServiciosRelacionados: 1926,
  SalonRegularConServiciosSuplementarios: 1927,
  ServiciosRelacionadosEnOficinaDelProveedor: 1998,
  SalonEspecialEnEscuelaRegular: 107,
  EscuelaEducacionEspecial: 108,
  InstruccionesEnElHogar: 110,
  UbicacionUnoaUno: 848,
  EducacionTempranaEnSalonEspecial: 2000,
  EducacionTempranaEnHospital: 2002,
  EducacionEspecialEnElAmbienteNatural: 3121,
  SalonRegular: 3157
};

export default alternatePlacements;
